
import { Button, Container } from 'react-bootstrap';
import './App.css';
import { Dialog } from './support/modal_dialog';
import { MainMenu } from './app/ux/EMainMenu';
import { onColResizeMouseLeave, onAppMouseMove, onColResizeMouseUp } from './app/ux/Column';
import { Popup } from './support/popup';
import { Script } from './app/ux/EScript';
import { useCookie, useProperty } from './support/general';
import { useState } from 'react';
import { modelStore } from './app/storage/model';
import { Security } from './app/ux/Security';

function App() {

  const [getFocussedSubscriptId,setFocussedSubscriptId] = useProperty(2);

  function onFocussedSubscriptChanged(value){
    setFocussedSubscriptId(value)
  }

  var password = modelStore.useSelector(state=>{
      return state.password;
  });

  var script = null;

  // if (password=="Anabe11e"){
  //   script = <Script
  //       style = {{
  //         width : '100%',
  //         flex: 1,
  //         overflow : 'hidden'  
  //       }} 
  //       scriptId="1" 
  //       subListId="main"
  //       onFocussedSubscriptChanged = {onFocussedSubscriptChanged}
  //   />
  // }
  return (
    <Container fluid className="App m-0 p-0" 
      style ={{
        height : '100vh',
        width : '100vw',
        display: 'flex',
        flexFlow: 'column',
        position : 'relative'
      }}
      id ="App"
      onMouseMove = { onAppMouseMove }
      onMouseUp = { onColResizeMouseUp }
      onMouseLeave = { onColResizeMouseLeave }
    >
      <MainMenu scriptId={1} focussedSubscriptId={getFocussedSubscriptId()}/>
      <Script
        style = {{
          width : '100%',
          flex: 1,
          overflow : 'hidden'  
        }} 
        scriptId="1" 
        subListId="main"
        onFocussedSubscriptChanged = {onFocussedSubscriptChanged}
    />
      <Dialog />
      <Popup />
      <Security style={{
        display : password=='Anabe11e'?'none':'block',
      }}/>
    </Container>
  );
}


export default App;
